module.exports = __webpack_public_path__ + "img/tovim_hashnaim_no.ba36ef51.png";